import { FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';
import { DATE_FORMAT_YYYY } from 'constants/formats';
import dayjs from 'dayjs';

import { DatePickerControl } from 'components/_basic/Form/DatePicker';
import { TextInputControl } from 'components/_basic/Form/TextInput';
import { BorderedCard } from 'components/BorderedCard';
import { ISectionRowProps as IProps } from 'components/BusinessToolForm';

import { concatWithDot } from 'helpers/string';

import { LIST_OF_KEY_EVENTS_FIELDS } from '../../utils/form';

export const KeyEventsRow: FC<IProps> = memo(({ name, maxLength, multiline, hiddenLabel, disabled = false }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <BorderedCard>
      <Grid container spacing={3}>
        <Grid item xs={8}>
          <TextInputControl
            control={control}
            multiline={multiline}
            maxLength={maxLength}
            hiddenLabel={hiddenLabel}
            id={concatWithDot(name, LIST_OF_KEY_EVENTS_FIELDS.TITLE)}
            label={t('company.history.keyEvents.title')}
            name={concatWithDot(name, LIST_OF_KEY_EVENTS_FIELDS.TITLE)}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={4}>
          <DatePickerControl
            control={control}
            maxDate={dayjs()}
            id={concatWithDot(name, LIST_OF_KEY_EVENTS_FIELDS.DATE)}
            label={t('company.history.keyEvents.date')}
            name={concatWithDot(name, LIST_OF_KEY_EVENTS_FIELDS.DATE)}
            disabled={disabled}
            dateFormat={DATE_FORMAT_YYYY}
            views={['year']}
          />
        </Grid>
      </Grid>
    </BorderedCard>
  );
});
